import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    approveSuccess: (requesterUser: string, grantedProject: string) => string;
    declineSuccess: (requesterUser: string, grantedProject: string) => string | React.ReactNode;
    successToastCta: string;
    undoDeclineCta: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Confirmation for approval success */
            approveSuccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (requesterUser: string, grantedProject: string): string => __intl__.intl().formatMessage({ id: "AccessRequestActionsConfirmation.approveSuccess?c=1qq1gyohas6jt", defaultMessage: "{requesterUser} was added to {grantedProject}" }, { requesterUser: requesterUser, grantedProject: grantedProject }));
                },
                enumerable: true,
                configurable: true
            },
            /** Confirmation for decline success */
            declineSuccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (requesterUser: string, grantedProject: string) => __intl__.intl().formatMessage({ id: "AccessRequestActionsConfirmation.declineSuccess?c=33w5b0ughi6m8", defaultMessage: "You declined {requesterUser} access to {grantedProject}" }, { requesterUser: requesterUser, grantedProject: grantedProject }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA to view the members of the project */
            successToastCta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestActionsConfirmation.successToastCta?c=3gggk12jubpod", defaultMessage: "View" }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA to undo the decline */
            undoDeclineCta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestActionsConfirmation.undoDeclineCta?c=n4og3f213zda", defaultMessage: "Undo" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
